var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('nav',{staticClass:"flex items-start"},_vm._l((_vm.tabs),function(tab,index){return _c('button',_vm._b({key:index,staticClass:"py-2 px-6 rounded hover:bg-primary-200 transition sticky",class:{
      'bg-primary-200': index === _vm.selectedTab,
      'text-primary-700': index === _vm.selectedTab,
      'text-neutral-600': index !== _vm.selectedTab && !tab.disabled,
      'mr-4': (index + 1) < _vm.tabs.length,
      'mr-4': (index + 1) < _vm.tabs.length,
      'cursor-not-allowed hover:bg-neutral-300 text-neutral-500': tab.disabled,
    },attrs:{"disabled":tab.disabled},on:{"click":function($event){return _vm.selectTab(index)}}},'button',_vm.$attrs,false),[_vm._v(" "+_vm._s(tab.label)+" ")])}),0),_vm._t("default"),(_vm.selectedTab === null)?_c('not-found-data',{staticClass:"mt-12"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }